import React from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Cities } from "./Cities";
import { Banks } from "./Banks";
import { Qualifications } from "./Qualifications";
import { Ports } from "./Ports";
import { Directions } from "./Directions";
import { ServiceCenters } from "./ServiceCenters";
import { Transportation } from "./Transportation";
import { Airlines } from "./Airlines";
import { States } from "./States";
import { HouseExaminationItemsList } from "./HouseExaminationItemsList";
import { ExaminationPeriodsList } from "./ExaminationPeriodsList";
import { PeriodCodesList } from "./PeriodCodesList";
import { MakkahPilgrimGroupNameMappings } from "./MakkahPilgrimGroupNameMappings";
import { Departments } from "./Departments";
import { Jobs } from "./Jobs";
import { JobSectors } from "./JobSectors";

export const BasicDataTabs = () => {
  const { key } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const activeTab = key || "cities";
  const isSeasonalHr = location.pathname.includes("seasonal_hr");
  const isMadina = location.pathname.includes("madina");
  const basePath = isSeasonalHr
    ? "/app/seasonal_hr/basic-data"
    : isMadina
      ? "/app/madina/basic-data"
      : "/app/makkah/basic-data";
  const defaultTab = isSeasonalHr ? "qualifications" : "cities";

  // Handle tab change and navigate to the corresponding route
  const handleTabChange = (tabKey) => {
    navigate(`${basePath}/${tabKey}`);
  };

  const allItems = [
    {
      key: "makkah-pilgrim-group-name-mappings",
      label: t("MAKKAH_PILGRIM_GROUP_NAME_MAPPINGS"),
      children: <MakkahPilgrimGroupNameMappings />,
    },
    {
      key: "cities",
      label: t("BASIC_DATA_TAB_CITIES"),
      children: <Cities />,
    },
    {
      key: "ports",
      label: t("BASIC_DATA_TAB_PORTS"),
      children: <Ports />,
    },
    {
      key: "directions",
      label: t("BASIC_DATA_TAB_DIRECTIONS"),
      children: <Directions />,
    },
    {
      key: "service-centers",
      label: t("BASIC_DATA_TAB_SERVICE_CENTERS"),
      children: <ServiceCenters />,
    },
    {
      key: "transportations",
      label: t("BASIC_DATA_TAB_TRANSPORTATIONS"),
      children: <Transportation />,
    },
    {
      key: "airlines",
      label: t("BASIC_DATA_TAB_AIRLINES"),
      children: <Airlines />,
    },
    {
      key: "states",
      label: t("BASIC_DATA_TAB_STATES"),
      children: <States />,
    },
    {
      key: "house_examination_items",
      label: t("INSPECTION_ITEMS"),
      children: <HouseExaminationItemsList />,
    },
    {
      key: "examination_periods",
      label: t("EXAMINATION_PERIODS"),
      children: <ExaminationPeriodsList />,
    },
    {
      key: "period_codes",
      label: t("PERIOD_CODES"),
      children: <PeriodCodesList />,
    },
    // {
    //   key: "campaigns",
    //   label: <></>,
    //   children: <InitialCampaigns />,
    // },
    // {
    //   key: "groups",
    //   label: <></>,
    //   children: <InitialGroups />,
    // },
  ];

  const items = isSeasonalHr
    ? [
      {
        key: "qualifications",
        label: t("BASIC_DATA_TAB_QUALIFICATIONS"),
        children: <Qualifications />,
      },
      {
        key: "banks",
        label: t("BASIC_DATA_TAB_BANKS"),
        children: <Banks />,
      },
      {
        key: "job-sectors",
        label: t("JOB_SECTORS"),
        children: <JobSectors />,
      },
      {
        key: "departments",
        label: t("BASIC_DATA_TAB_DEPARTMENTS"),
        children: <Departments />,
      },
      {
        key: "jobs",
        label: t("BASIC_DATA_TAB_JOBS"),
        children: <Jobs />,
      },
    ]
    : allItems;

  return (
    <Stack gap={3}>
      <PageHeader />
      <Tabs
        activeKey={activeTab || defaultTab}
        onChange={handleTabChange}
        items={items}
      />
    </Stack>
  );
};
